module.exports = __webpack_public_path__ + "static/media/Icon5.48904db2.png";